import { render } from "./Step0ShowRoom.vue?vue&type=template&id=74edf5bc"
const script = {}

import "./Step0ShowRoom.vue?vue&type=style&index=0&id=74edf5bc&lang=css"
script.render = render

export default script